module.exports = __webpack_public_path__ + "static/media/IMG_1292.6c465437.jpg";